import { render, staticRenderFns } from "./PricingOne.vue?vue&type=template&id=02957199&"
import script from "./PricingOne.vue?vue&type=script&lang=js&"
export * from "./PricingOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports